import React from 'react';

import LogoOutlineWhite from '../../../../assets/brand/LogoOutlineWhite';
import IconMenuHamburger from '../../../../Icons/MenuHamburger';
import { useLayoutMenuContext } from '../../context/LayoutMenuContext';
import * as S from './styles';

export const Header: React.FC = () => {
  const { onCollapse, isMobile } = useLayoutMenuContext();
  if (!isMobile) return null;
  return (
    <S.Header>
      <IconMenuHamburger onClick={onCollapse} />
      <LogoOutlineWhite />
    </S.Header>
  );
};
